/**
 * @generated SignedSource<<1e58a5c14658e9b24887773151d07af7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SignatureEnvelopeState = "CANCELLED" | "CERTIFYING" | "COMPLETED" | "COMPLETING" | "SIGNING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RequestSignaturesOption_node$data = {
  readonly __typename: string;
  readonly canCreateSignatureEnvelope?: {
    readonly value: boolean;
  };
  readonly id: string;
  readonly signatureEnvelope?: {
    readonly id: string;
    readonly status: SignatureEnvelopeState;
  } | null;
  readonly " $fragmentType": "RequestSignaturesOption_node";
};
export type RequestSignaturesOption_node$key = {
  readonly " $data"?: RequestSignaturesOption_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestSignaturesOption_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestSignaturesOption_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canCreateSignatureEnvelope",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SignatureEnvelope",
          "kind": "LinkedField",
          "name": "signatureEnvelope",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "SignableInterface",
      "abstractKey": "__isSignableInterface"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "ceb42d54f1247144f6de8cbe57267371";

export default node;
